/* Load Modules */
import React, { Component } from "react";

/* Load Components */
import Footer from "../home/components/Footer/footer.component";
import Background from "../../utils/Background/Background.component";
import Collapse from "../../utils/Collapse/Collapse.component";

/* Load Styles */
import "./help.component.scss";

/* Load Json */
import faq from "../../jsons/faq.json";
import subapps from "../../jsons/subapps.json";

class HelpComponentPage extends Component {
    render() {
        return (
            <div id="help-page">
                <Background />
                <div className="page-container">
                    <h1>Help</h1>

                    <h2>What's Wave?</h2>
                    <p>
                        Wave is a framework that centralizes data and
                        interconnects multiple systems produced by Fabamaq. Due
                        to the interdependence that those systems had between
                        each other, Wave acts as a centralized and unified
                        source of data that is shared between systems.
                    </p>
                    <p>
                        Wave also enables the automation of processes, remote
                        configuration, and execution of remote commands on those
                        systems. Examples of these remote operations are the
                        monitoring of systems, deployment of new games and
                        promotional video packages.
                    </p>

                    <h2>It's Subparts...</h2>
                    <div className="help-subparts">
                        {subapps.map((column, index) => {
                            return (
                                <div key={index}>
                                    {column.map((app, key) => {
                                        return (
                                            <React.Fragment key={key}>
                                                <h3>{app.title}</h3>
                                                <p>{app.description}</p>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>

                    {/*<h2>F.A.Q</h2>
                    <Collapse items={faq} />*/}
                </div>
                <Footer />
            </div>
        );
    }
}

export default HelpComponentPage;
